<template>
  <div class="container">
    <h3 class="title" v-if="!accepted && !declined">Twoje ostatnie zgłoszenie miało numer {{itemNumber}}<br/> Czy to o tę sprawę chciałbyś/chciałabyś zapytać?</h3>
    <h3 class="title" v-if="accepted && !declineSubmitted">W ciągu kilku minut zadzwoni konsultant i przekaże informacje dotyczące sprawy</h3>
    <!-- TODO review this -->
    <h3 class="title" v-if="false">Prosimy o kontakt z konsultantem, celem wyjaśnienia nieścisłości.</h3>
    <h3 class="title" v-if="declined">Podaj numer sprawy</h3>
    <div class="btn-group" v-if="!declined">
      <button type="button" class="btn gray" @click="declined = true" v-if="!accepted">Nie</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler">
        {{ accepted ? 'Menu' : 'Tak' }}
      </button>
    </div>

    <!-- TODO is this even used? -->
    <form @submit.prevent="setUserNumber" v-else>
      <div class="field">
        <input type="text" class="input" v-model="number">
        <button type="submit" class="arrow">
          <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3415 0.247437C15.7571 -0.116245 16.3889 -0.0741276 16.7526 0.341509L23.7526 8.34151C24.0825 8.71853 24.0825 9.28149 23.7526 9.65852L16.7526 17.6585C16.3889 18.0742 15.7571 18.1163 15.3415 17.7526C14.9259 17.3889 14.8837 16.7571 15.2474 16.3415L20.7962 10H1C0.447715 10 0 9.5523 0 9.00001C0 8.44773 0.447715 8.00001 1 8.00001H20.7962L15.2474 1.65852C14.8837 1.24288 14.9259 0.611119 15.3415 0.247437Z" :fill="$color"/>
          </svg>
        </button>
      </div>
    </form>

    <MissingDataModal :bus="bus"/>
  </div>
</template>

<script>

// This template is used both for the end of case creation and for the claim request screen

import { mapState, mapMutations, mapActions } from 'vuex'
import MissingDataModal from "../shared/MissingDataModal";
import Vue from "vue";

export default {
  name: "Result",
  components: {MissingDataModal},
  data () {
    return {
      declined: false,
      declineSubmitted: false,
      number: null,
      accepted: this.isAccepted,

      bus: new Vue(),
    }
  },
  props: {
    isAccepted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['itemNumber'])
  },
  methods: {
      ...mapMutations(['setHomePage', 'setNumber']),
      btnHandler () {
          if (this.accepted) {
              this.setHomePage()
          } else {
              this.accepted = true;

              this.bus.$emit('attemptSendUserQuestion');
          }
      },
      setUserNumber () {
          this.setNumber(this.number)
          this.declined = false
          // this.declineSubmitted = true
          this.accepted = true;

          this.bus.$emit('attemptSendUserQuestion');
      },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/case_steps/Result.vue